<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chaptertitle"><a id="p1"></a> RISE AND RIDE: BREAKFAST</h1>
<p class="first"><img alt="[Image]" class="art" id="fig_BikerBillysHogWildOnAHarleyCookbook-18" src="images/BikerBillysHogWildOnAHarleyCookbook-18.jpg" width="100%"/></p>
<p class="left">Breakfast is the first and, as it is said, the most important meal of the day. Most of us would not start a long ride with an empty gas tank on the Harley, yet a lot of people will skip breakfast to get an earlier start on the road. I have been known to ride a hundred or more miles before breakfast while touring the country on my Road King. Somehow that morning dose of fresh air and the rumble of my big twin motor builds a healthy appetite; indeed, I am usually starved by the time I belly up to the breakfast table. Yet when I am at home, I like to eat a good breakfast before I start my ride. Go figure, I guess the availability of a kitchen changes my morning appetite.</p>
<p class="follow">I also enjoy breakfast as dinner sometimes, since breakfast foods are often what can be called comfort foods. This chapter has some yummy breakfast dishes to fuel your ride, whether you choose to eat before you start riding or pack some breakfast to enjoy along the road at your favorite scenic pullout. Whenever or wherever you serve them, these recipes will surely please any hungry biker at your table. Try sharing them with your non-riding friends too and maybe you just might inspire them to take a Motorcycle Safety Foundation Rider Education Course (MSF-REC) like the Rider's Edge classes that many Harley-Davidson dealers now offer. Wouldn't it be great to share your passion for all things Harley with a friend while guiding them toward being a safe rider?</p>
<p class="timebreak"> <br/></p>
<p class="left"><a id="p2"></a> <b>Lisa Peters's Rally Circuit Honey Nut Granola <a href="#/c001#p3">[&gt;]</a></b></p>
<p class="left"><b>Lisa's Day-Long Muffins <a href="#/c002#p4">[&gt;]</a></b></p>
<p class="left"><b>DeDe Vecchio's Sturgis Farmer's Omelet <a href="#/c003#p5">[&gt;]</a></b></p>
<p class="left"><b>Dena Sheets's Fiery Breakfast Burritos <a href="#/c004#p6">[&gt;]</a></b></p>
<p class="left"><b>Rich's Dine and Dash Potatoes <a href="#/c005#p7">[&gt;]</a></b></p>
<p class="left"><b>Daria Schooler's Altered States Pancakes <a href="#/c006">[&gt;]</a></b></p>
<p class="left"><b>Kathy Austin's Nutty French Toast <a href="#/c007#p9">[&gt;]</a></b></p>
<p class="follow"></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c0001.vue?7b4cd73c